import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContextProvider';
import bootbox from 'bootbox';
import { ProfileImg } from '../helper';
import { useModuleContext } from '../../context/ModuleProvider';

function ProfileImage({ url }) {
  let { moduleId } = useModuleContext();
  let { currentUser, loadUser, updateProfile } = useContext(AuthContext);
  let [selectedFile, setSelectedFile] = useState(false);
  let [uploaded, setUploaded] = useState(false);
  let [imageUrl, setImageUrl] = useState(false);
  let [loading, setLoading] = useState(false);
  const imageSelecter = React.useRef(null);
  let { avatar, first_name, middle_name, last_name } = currentUser;

  const uploadPicture = async () => {
    let data = {};
    setLoading(true);
    if (selectedFile && selectedFile instanceof File) {
      const formData = new FormData();
      formData.append('image', selectedFile);
      const response = await fetch(`${process.env.REACT_APP_FILE_UPLOAD_URL}api/video/image/`, {
        method: 'POST',
        body: formData,
        headers: {
          Authorization: process.env.REACT_APP_VIDEO_AUTH,
        },
      }).then((res) => {
        setLoading(false);
        return res.json();
      });
      data.avatar = response.url.split('?')[0].split('/').pop();
    }

    try {
      await updateProfile(data, moduleId);
      await loadUser();
      setSelectedFile(null);
      setUploaded(false);
      setLoading(false);
    } catch {
      bootbox.alert('Error uploading image');
    }
  };
  return (
    <>
      <div className="profile__page__picture">
        <ProfileImg src={selectedFile ? imageUrl : avatar} alt="profile" />
      </div>
      <div className="profile__page__header">
        <div className="profile__page__account">
          <h4 className="profile__page__username d-block w-75">
            {first_name} {middle_name} {last_name}
          </h4>
        </div>
        {/* change profile pic */}
        {/* change profile apperas in big and icon in small */}
        <div className="profile__page__edit">
          <div
            onClick={uploaded ? uploadPicture : () => imageSelecter.current.click()}
            className="btn btn-outline-dark btn-sm"
            href="#"
          >
            <input
              type="file"
              id="FileUpload1"
              onChange={(e) => {
                const file = e.target.files[0];
                setSelectedFile(file);
                if (file) {
                  setImageUrl(URL.createObjectURL(file));
                  setUploaded(true);
                }
              }}
              ref={imageSelecter}
              name="userfile"
              style={{ display: 'none' }}
            />
            <span className="d-md-block d-none">
              {loading ? 'Saving...' : uploaded ? 'Save Profile' : 'Change'}&nbsp;
            </span>
            <span className="d-md-none d-block">
              {uploaded ? <i className="fas fa-save" /> : <i className="fas fa-camera" />}
            </span>
          </div>
        </div>
      </div>
    </>
  );
}

const getProfileLink = (link) => {
  let serverUrl = process.env.REACT_APP_SERVER_URL;
  if (!link) {
    return '/images/profile.png';
  } else if (link.startsWith('https://')) {
    return link;
  } else {
    return `${serverUrl}/${link}`;
  }
};

export default ProfileImage;
